export const articlesSelfcare = [
  {
    id: "selfcare-1",
    title: "自我关怀：把温柔留给自己",
    summary:
      "我们常常对别人温柔，却对自己苛刻。自我关怀不是自私，而是一种让生活更稳固的底层能力。",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20minimal%20abstract%20illustration%20of%20soft%20teal%20and%20peach%20embrace%20shapes%2C%20gentle%20self%20care%20wellness%20editorial%20style&width=800&height=600&seq=care-01&orientation=landscape",
    categoryId: "selfcare",
    author: "编辑部",
    date: "2026-09-29",
    readCount: 7920,
    tags: ["自我关怀", "理念"],
    sections: [
      {
        heading: "它到底是什么",
        paragraphs: [
          "自我关怀指的是像对待好朋友那样对待自己，包括理解自己的情绪、允许自己不完美。",
        ],
      },
      {
        heading: "从小事开始",
        paragraphs: [
          "保证休息、说一句鼓励自己的话、在疲惫时允许暂停，都是具体的关怀。",
        ],
      },
      {
        heading: "它是一种练习",
        paragraphs: [
          "自我关怀不会一夜之间改变习惯，但每一次温柔的对待，都会累积成更稳定的内心。",
        ],
      },
    ],
  },
  {
    id: "selfcare-2",
    title: "建立健康的独处时光",
    summary:
      "独处不等于孤独。学会有质量地与自己相处，是一种重要的能力，也能让身心得到真正的休息。",
    cover:
      "https://readdy.ai/api/search-image?query=peaceful%20minimal%20abstract%20illustration%20of%20a%20calm%20teal%20space%20with%20warm%20light%2C%20solitude%20wellness%20editorial%20style&width=800&height=600&seq=care-02&orientation=landscape",
    categoryId: "selfcare",
    author: "编辑部",
    date: "2026-09-26",
    readCount: 4310,
    tags: ["独处", "休息"],
    sections: [
      {
        heading: "独处的价值",
        paragraphs: [
          "在没有外界打扰的时间里，情绪更容易被听见，思绪也更容易沉淀。",
        ],
      },
      {
        heading: "怎么度过更好",
        paragraphs: [
          "可以试试阅读、散步、听音乐或什么都不做，重点是把注意力放回自己身上。",
        ],
      },
    ],
  },
  {
    id: "selfcare-3",
    title: "睡眠卫生：为身心充电的仪式",
    summary:
      "好的睡眠不是靠运气，而是可以培养的习惯。本文分享几个简单却有效的睡眠卫生建议。",
    cover:
      "https://readdy.ai/api/search-image?query=calm%20night%20minimal%20abstract%20illustration%20with%20deep%20teal%20and%20soft%20amber%2C%20sleep%20wellness%20editorial%20style&width=800&height=600&seq=care-03&orientation=landscape",
    categoryId: "selfcare",
    author: "编辑部",
    date: "2026-09-23",
    readCount: 5080,
    tags: ["睡眠", "习惯"],
    sections: [
      {
        heading: "固定作息",
        paragraphs: [
          "每天在相近的时间入睡与起床，能帮助身体建立稳定的节律。",
        ],
      },
      {
        heading: "睡前一小时",
        paragraphs: [
          "减少屏幕时间、调暗灯光、做些放松的事，让身体知道该休息了。",
        ],
      },
    ],
  },
  {
    id: "selfcare-4",
    title: "情绪日记：与自己对话的方式",
    summary:
      "把感受写下来，是一种简单又有力的情绪调节方法。本文教你如何开始第一本情绪日记。",
    cover:
      "https://readdy.ai/api/search-image?query=cozy%20minimal%20abstract%20illustration%20of%20soft%20teal%20pages%20and%20warm%20writing%20light%2C%20journaling%20wellness%20editorial%20style&width=800&height=600&seq=care-04&orientation=landscape",
    categoryId: "selfcare",
    author: "编辑部",
    date: "2026-09-20",
    readCount: 3760,
    tags: ["情绪", "日记"],
    sections: [
      {
        heading: "为什么写作有效",
        paragraphs: [
          "把情绪变成文字，能拉开一点距离，让你从“被情绪淹没”转向“观察情绪”。",
        ],
      },
      {
        heading: "可以这样写",
        paragraphs: [
          "记录发生了什么、你有什么感受、你希望怎样，不需要修饰，真实就好。",
        ],
      },
    ],
  },
  {
    id: "selfcare-5",
    title: "练习身体放松的5个方法",
    summary:
      "紧张会积累在身体里。这里有五个可以随时做的放松方法，帮你快速回到平静的状态。",
    cover:
      "https://readdy.ai/api/search-image?query=soothing%20minimal%20abstract%20illustration%20of%20soft%20teal%20breathing%20circles%20with%20warm%20tones%2C%20relaxation%20wellness%20editorial%20style&width=800&height=600&seq=care-05&orientation=landscape",
    categoryId: "selfcare",
    author: "编辑部",
    date: "2026-09-17",
    readCount: 4620,
    tags: ["放松", "练习"],
    sections: [
      {
        heading: "深呼吸",
        paragraphs: [
          "缓慢地用鼻子吸气、用嘴呼气，重复几次，就能让神经系统逐渐平静下来。",
        ],
      },
      {
        heading: "渐进式肌肉放松",
        paragraphs: [
          "依次收紧再放松各个部位，感受紧张与松弛的差别，身心会随之舒缓。",
        ],
      },
      {
        heading: "更多选择",
        paragraphs: [
          "伸展、温水泡脚、安静地听一段音乐，同样有效。找到适合自己的即可。",
        ],
      },
    ],
  },
  {
    id: "selfcare-6",
    title: "设定健康的边界",
    summary:
      "边界不是把人推开，而是让自己在关系里更自在。本文聊聊如何温和而坚定地表达自己的界限。",
    cover:
      "https://readdy.ai/api/search-image?query=clear%20minimal%20abstract%20illustration%20of%20a%20gentle%20teal%20boundary%20line%20with%20warm%20accent%2C%20wellness%20editorial%20style&width=800&height=600&seq=care-06&orientation=landscape",
    categoryId: "selfcare",
    author: "编辑部",
    date: "2026-09-14",
    readCount: 3290,
    tags: ["边界", "关系"],
    sections: [
      {
        heading: "边界是什么",
        paragraphs: [
          "它是你对自己时间、精力和感受的保护线，帮助你分清哪些是愿意的、哪些不是。",
        ],
      },
      {
        heading: "如何表达",
        paragraphs: [
          "用平静、具体的语言说明你的需要，比忍耐或爆发都更有效。",
        ],
      },
    ],
  },
  {
    id: "selfcare-7",
    title: "减少屏幕时间，找回身体感受",
    summary:
      "长时间盯着屏幕会让人与身体的感觉脱节。适当放下手机，能重新连接自己的内在状态。",
    cover:
      "https://readdy.ai/api/search-image?query=minimal%20abstract%20illustration%20of%20a%20soft%20teal%20sunset%20with%20warm%20sand%20tones%2C%20digital%20detox%20wellness%20editorial%20style&width=800&height=600&seq=care-07&orientation=landscape",
    categoryId: "selfcare",
    author: "编辑部",
    date: "2026-09-11",
    readCount: 3080,
    tags: ["屏幕", "觉察"],
    sections: [
      {
        heading: "它在悄悄影响你",
        paragraphs: [
          "持续的信息刺激容易让注意力碎片化，也让人更难感受到真实的疲惫与情绪。",
        ],
      },
      {
        heading: "试试这样",
        paragraphs: [
          "每天留出一段时间不看屏幕，去走走、伸展或发呆，让身体重新被听见。",
        ],
      },
    ],
  },
  {
    id: "selfcare-8",
    title: "冥想入门：给忙碌大脑的休息",
    summary:
      "冥想听起来很玄，其实很简单。本文用最平实的方式，带你完成第一次冥想练习。",
    cover:
      "https://readdy.ai/api/search-image?query=serene%20minimal%20abstract%20illustration%20of%20a%20still%20teal%20water%20surface%20with%20warm%20light%2C%20meditation%20wellness%20editorial%20style&width=800&height=600&seq=care-08&orientation=landscape",
    categoryId: "selfcare",
    author: "编辑部",
    date: "2026-09-08",
    readCount: 4020,
    tags: ["冥想", "入门"],
    sections: [
      {
        heading: "它没有那么复杂",
        paragraphs: [
          "冥想只是安静地坐着、关注呼吸，走神了就回来，不需要清空大脑。",
        ],
      },
      {
        heading: "第一次练习",
        paragraphs: [
          "找个安静的地方坐下，闭眼，专注呼吸五分钟即可。每天坚持比时长更重要。",
        ],
      },
    ],
  },
  {
    id: "selfcare-9",
    title: "培养可持续的作息习惯",
    summary:
      "健康的生活方式不是短期的冲刺，而是能长期坚持的小习惯。本文帮你建立可持续的作息。",
    cover:
      "https://readdy.ai/api/search-image?query=steady%20minimal%20abstract%20illustration%20of%20soft%20teal%20rhythm%20waves%20with%20warm%20tones%2C%20routine%20wellness%20editorial%20style&width=800&height=600&seq=care-09&orientation=landscape",
    categoryId: "selfcare",
    author: "编辑部",
    date: "2026-09-05",
    readCount: 2870,
    tags: ["习惯", "作息"],
    sections: [
      {
        heading: "从小目标开始",
        paragraphs: [
          "一次只改变一个习惯，完成后再加一个，成功感会帮助你坚持下去。",
        ],
      },
      {
        heading: "允许偶尔中断",
        paragraphs: [
          "中断不等于失败，重要的是愿意重新开始，而不是苛责自己。",
        ],
      },
    ],
  },
  {
    id: "selfcare-10",
    title: "求助不羞耻：何时寻找专业支持",
    summary:
      "每个人都会有需要帮助的时刻。了解什么时候寻求专业支持，是对自己负责的表现，而不是软弱。",
    cover:
      "https://readdy.ai/api/search-image?query=supportive%20minimal%20abstract%20illustration%20of%20gentle%20teal%20hands%20and%20warm%20light%2C%20help%20and%20care%20wellness%20editorial%20style&width=800&height=600&seq=care-10&orientation=landscape",
    categoryId: "selfcare",
    author: "编辑部",
    date: "2026-09-02",
    readCount: 3410,
    tags: ["求助", "支持"],
    sections: [
      {
        heading: "什么时候可以求助",
        paragraphs: [
          "当困扰持续存在、影响日常生活，或让你感到难以独自承受时，专业支持就值得考虑。",
        ],
      },
      {
        heading: "有哪些选择",
        paragraphs: [
          "心理咨询、医生门诊、可信赖的支持热线，都是可以使用的资源。",
          "主动求助，是照顾自己的重要一步。",
        ],
      },
    ],
  },
];